import React, { useState } from 'react';

/**
 * A generic component for multi-language text entry.
 * It stores data as: { fr: '...', en: '...', ar: '...' }
 */
const MultiLangInput = ({ value, onChange, type = 'text', languages = ['fr', 'en', 'ar'], placeholder = '' }) => {
  const [activeLang, setActiveLang] = useState('fr');

  // Handle value being a string (legacy/single-lang)
  const safeValue = typeof value === 'object' && value !== null ? value : { fr: value || '', en: '', ar: '' };

  const handleLangChange = (lang, newValue) => {
    const updated = { ...safeValue, [lang]: newValue };
    onChange(updated);
  };

  const getLangLabel = (code) => {
    const labels = { fr: '🇫🇷 FR', en: '🇬🇧 EN', ar: '🇲🇦 AR', es: '🇪🇸 ES', de: '🇩🇪 DE' };
    return labels[code] || code.toUpperCase();
  };

  return (
    <div className="multi-lang-input-container" style={{ border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden', backgroundColor: 'white' }}>
      <div className="lang-tabs" style={{ display: 'flex', borderBottom: '1px solid #eee', backgroundColor: '#f9f9f9' }}>
        {languages.map(lang => (
          <button
            key={lang}
            type="button"
            onClick={(e) => { e.preventDefault(); setActiveLang(lang); }}
            style={{
              padding: '8px 15px',
              border: 'none',
              backgroundColor: activeLang === lang ? 'white' : 'transparent',
              borderBottom: activeLang === lang ? '2px solid #002b5b' : 'none',
              cursor: 'pointer',
              fontWeight: activeLang === lang ? '600' : '400',
              color: activeLang === lang ? '#002b5b' : '#666',
              fontSize: '13px'
            }}
          >
            {getLangLabel(lang)}
          </button>
        ))}
        <div style={{ marginLeft: 'auto', padding: '8px 15px', fontSize: '11px', color: '#999', display: 'flex', alignItems: 'center' }}>
          Mode Expert (Multi-langues)
        </div>
      </div>
      <div className="lang-content" style={{ padding: '10px' }}>
        {type === 'textarea' ? (
          <textarea
            value={safeValue[activeLang] || ''}
            onChange={(e) => handleLangChange(activeLang, e.target.value)}
            style={{ width: '100%', minHeight: '100px', border: 'none', outline: 'none', fontFamily: activeLang === 'ar' ? "'Tajawal', sans-serif" : 'inherit', direction: activeLang === 'ar' ? 'rtl' : 'ltr' }}
            placeholder={`${placeholder} [${getLangLabel(activeLang)}]`}
          />
        ) : (
          <input
            type="text"
            value={safeValue[activeLang] || ''}
            onChange={(e) => handleLangChange(activeLang, e.target.value)}
            style={{ width: '100%', border: 'none', outline: 'none', padding: '5px 0', fontFamily: activeLang === 'ar' ? "'Tajawal', sans-serif" : 'inherit', direction: activeLang === 'ar' ? 'rtl' : 'ltr' }}
            placeholder={`${placeholder} [${getLangLabel(activeLang)}]`}
          />
        )}
      </div>
    </div>
  );
};

export default MultiLangInput;
